import React, { Component } from 'react';
import { Field, reduxForm, change, formValueSelector, FieldArray } from 'redux-form';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import { injectIntl } from 'react-intl';
import cx from 'classnames';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Row from 'react-bootstrap/Row';
import FormControl from 'react-bootstrap/FormControl';
import FormGroup from 'react-bootstrap/FormGroup';
import Button from 'react-bootstrap/Button';

import Loader from '../../Common/Loader';
import ImageUploadComponent from '../../../components/Common/ImageUploadComponent';

import { updateTempImages } from '../../../actions/siteadmin/TempImages/updateTempImages';
import { api, homepageUploadDir } from '../../../config';
import messages from '../../../locale/messages';
import validate from './validate';
import submit from './submit';
import { formatLocale } from '../../../helpers/formatLocale';

import addIcon from '../../../../public/Icons/plusIcon.svg';
import trashIcon from '../../../../public/Icons/deleteIocn.svg';

import s from './SignupSettingsForm.css';
import bt from '../../../components/commonStyle.css';

export class SignupSettingsForm extends Component {

	constructor(props) {
		super(props)
		this.state = {
			selectedLanguages: []
		};
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		const { dynamicSignupGridTitle } = nextProps;
		let filteredLanguages = dynamicSignupGridTitle?.map((item) => { return item?.language })
		this.setState({ selectedLanguages: filteredLanguages });
	}

	successLogo = async (fileName) => {
		const { change, updateTempImages } = this.props;
		await change('signupGridImage4', fileName);
		await updateTempImages('Homepage', 'signupGridImage4', fileName);
	}

	successBanner = async (fileName) => {
		const { change, updateTempImages } = this.props;
		await change('signupGridImage3', fileName);
		await updateTempImages('Homepage', 'signupGridImage3', fileName);
	}

	successAppStore = async (fileName) => {
		const { change, updateTempImages } = this.props;
		await change('signupGridImage2', fileName);
		await updateTempImages('Homepage', 'signupGridImage2', fileName);
	}

	successPlayStore = async (fileName) => {
		const { change, updateTempImages } = this.props;
		await change('signupGridImage1', fileName);
		await updateTempImages('Homepage', 'signupGridImage1', fileName);
	}

	renderField = ({ input, label, type, meta: { touched, error }, labelClass, fieldClass, placeholder, maxlength, inputClassname }) => {
		const { formatMessage } = this.props.intl
		return (
			<Form.Group className={inputClassname}>
				{label && <label className={bt.labelText} >{label}</label>}
				<Form.Control {...input} placeholder={placeholder} type={type} className={bt.formControlInput} maxlength={maxlength} />
				{touched && error && <span className={cx(bt.errorMessage, 'errorRTL')}>{formatMessage(error)}</span>}
			</Form.Group>
		)
	}
	renderFormControlTextArea = ({ input, label, meta: { touched, error }, children, className, maxlength }) => {
		const { formatMessage } = this.props.intl
		return (
			<div>
				<FormGroup className={cx(s.formGroup, 'noMargin')}>
					<div>
						<label className={bt.labelText} >{label}</label>
					</div>
					<div>
						<FormControl
							{...input}
							className={className}
							placeholder={label}
							as="textarea"
							rows="3"
							maxlength={maxlength}
						>
							{children}
						</FormControl>
						{touched && error && <span className={cx(bt.errorMessage, 'errorRTL')}>{formatMessage(error)}</span>}
					</div>
				</FormGroup>
			</div>
		);
	}

	renderFormControlSelect = ({ input, meta: { touched, error }, className, children, label }) => {
		const { formatMessage } = this.props.intl;
		return (
			<div className={bt.space5}>
				{label && <label className={bt.labelText} >{label}</label>}
				<FormControl as="select" {...input} className={className} >
					{children}
				</FormControl>
				{touched && error && <span className={cx(bt.errorMessage, 'errorRTL')}>{formatMessage(error)}</span>}
			</div>
		)
	}

	renderFieldArray = ({ fields, meta: { touched, error } }) => {
		const { formatMessage } = this.props.intl;
		const { languageList } = this.props;
		const { selectedLanguages } = this.state;

		return (
			<div className={bt.languageBox}>
				{
					fields && fields.map((serviceProviderApp, index) => {
						let fieldLength = fields.length - 1;
						const currentLanguage = fields?.get(index)?.language;
						const availableLanguages = languageList?.filter(locale => !selectedLanguages?.includes(locale) || locale === currentLanguage);

						return (
							<div key={index}>
								<Row>
									<Col lg={6} md={6} sm={12} xs={12} className={bt.mb30Xs}>
										<Field name={`${serviceProviderApp}.language`} component={this.renderFormControlSelect} className={cx('noMargin', bt.formControlSelect, bt.formControlInput)} label={formatMessage(messages.language)}>
											<option value={''} >{formatMessage(messages.chooseLanguageLabel)}</option>
											{availableLanguages?.map((locale, index) => {
												return (
													<option value={locale} key={index}>{formatLocale(locale)}</option>
												)
											})}
										</Field>
										<Field name={`${serviceProviderApp}.value`} type="text" component={this.renderField} placeholder="Title" label={formatMessage(messages.partnerapptitle)} inputClassname={'noMargin'} />
									</Col>
									<Col lg={6} md={6} sm={12} xs={12} className={bt.noMargin}>
										<Field name={`${serviceProviderApp}.description`} component={this.renderFormControlTextArea} label={formatMessage(messages.partnerappcntn)} className={cx(bt.textAreaHeight)} />
									</Col>
								</Row>
								<div className={cx(bt.languageBtnContainer, 'darkLink', 'svgImg', { [bt.languageBtnContainerOne]: index != 0 })} >
									{(fields.length <= languageList?.length - 1) && fieldLength == index &&
										<Button className={cx(bt.languageBtn, "textWhite", "btnBorderWhte")} onClick={() => fields.length <= languageList?.length - 1 && fields.push({})}>
											<img src={addIcon} alt='addIcon' />
											<span>	{formatMessage(messages.addLanguage)}</span>
										</Button>
									}
									{index != 0 &&
										<div>
											<Button className={cx(bt.languageBtn, "textWhite", "btnBorderWhte")} onClick={() => fields.remove(index)}>
												<img src={trashIcon} alt='addIcon' />
												<span>{formatMessage(messages.deleteLanguage)}</span>
											</Button>
										</div>
									}
								</div>
							</div>
						)
					})
				}
			</div>
		)
	}

	render() {
		const { handleSubmit, signupGridImage1, signupGridImage2, signupGridImage3, loading, submitting, signupGridImage4 } = this.props;
		const { signupGridImage1Loader, signupGridImage2Loader, signupGridImage3Loader, signupGridImage4Loader } = this.props;
		const { formatMessage } = this.props.intl;
		return (
			<div className={cx('cardSection', s.widthInner, bt.space5, s.responsiveNoPadding)}>
				<div className={s.responsiveNoPadding}>
					<Card className={s.card}>
						<Form className={s.fullWidth} onSubmit={handleSubmit(submit)}>
							<h1 className={cx('textAlignRightRTL', s.headingTwo, 'textWhite')}>{formatMessage(messages.signupSectionSettings)}</h1>

							<Row>
								<Col lg={6} md={6} sm={12} xs={12} className={bt.space2}>
									<Form.Group className={s.formGroup}>
										<div className={cx(s.profileImgSection, 'bgBlackTwo')}>
											<div className={'commonFilepicker'}>
												<ImageUploadComponent
													className={cx(bt.btnPrimary, 'fileNoPadding', s.btnWidthadmin)}
													subTextClass={cx(s.subText, 'textWhiteTwo')}
													subText={formatMessage(messages.maximumUploadSizeLabel)}
													defaultMessage={formatMessage(messages.chooseFile)}
													postUrl={api.apiEndpoint + '/uploadHomepageImage'}
													handleDropzone={this.successLogo}
													loaderName={'signupGridImage1Loader'}
													loader={signupGridImage1Loader}
													imageSrc={signupGridImage4 ? api.apiEndpoint + homepageUploadDir + 'medium_' + signupGridImage4 : null}
													fieldName={'signupGridImage4'}
													formName={'SignupSettingsForm'}
													label={formatMessage(messages.backGroundImage)}
													labelClass={cx(s.textAlignLeft, 'textAlignLeft', s.dropzoneLabelTitle)}
												/>
											</div>
										</div>
									</Form.Group>
								</Col>
								<Col lg={6} md={6} sm={12} xs={12} className={bt.space2}>
									<Form.Group className={s.formGroup}>
										<div className={cx(s.profileImgSection, 'bgBlackTwo')}>
											<div className={'commonFilepicker'}>
												<ImageUploadComponent
													className={cx(bt.btnPrimary, 'fileNoPadding', s.btnWidthadmin)}
													subTextClass={cx(s.subText, 'textWhiteTwo')}
													subText={formatMessage(messages.maximumUploadSizeLabel)}
													defaultMessage={formatMessage(messages.chooseFile)}
													postUrl={api.apiEndpoint + '/uploadHomepageImage'}
													handleDropzone={this.successBanner}
													loaderName={'signupGridImage2Loader'}
													loader={signupGridImage2Loader}
													imageSrc={signupGridImage3 ? api.apiEndpoint + homepageUploadDir + 'medium_' + signupGridImage3 : null}
													fieldName={'signupGridImage3'}
													formName={'SignupSettingsForm'}
													label={formatMessage(messages.signupImage3)}
													labelClass={cx(s.textAlignLeft, 'textAlignLeft', s.dropzoneLabelTitle)}
												/>
											</div>
										</div>
									</Form.Group>
								</Col>
								<Col lg={6} md={6} sm={12} xs={12} className={bt.space2}>
									<Form.Group className={s.formGroup}>
										<div className={cx(s.profileImgSection, 'bgBlackTwo')}>
											<div className={'commonFilepicker'}>
												<ImageUploadComponent
													className={cx(bt.btnPrimary, 'fileNoPadding', s.btnWidthadmin)}
													subTextClass={cx(s.subText, 'textWhiteTwo')}
													subText={formatMessage(messages.maximumUploadSizeLabel)}
													defaultMessage={formatMessage(messages.chooseFile)}
													postUrl={api.apiEndpoint + '/uploadHomepageImage'}
													handleDropzone={this.successPlayStore}
													loaderName={'signupGridImage3Loader'}
													loader={signupGridImage3Loader}
													imageSrc={signupGridImage1 ? api.apiEndpoint + homepageUploadDir + 'medium_' + signupGridImage1 : null}
													fieldName={'signupGridImage1'}
													formName={'SignupSettingsForm'}
													label={formatMessage(messages.signupImage1)}
													labelClass={cx(s.textAlignLeft, 'textAlignLeft', s.dropzoneLabelTitle)}
												/>
											</div>
										</div>
									</Form.Group>
								</Col>
								<Col lg={6} md={6} sm={12} xs={12} className={bt.space2}>
									<Form.Group className={s.formGroup}>
										<div className={cx(s.profileImgSection, 'bgBlackTwo')}>
											<div className={'commonFilepicker'}>
												<ImageUploadComponent
													className={cx(bt.btnPrimary, 'fileNoPadding', s.btnWidthadmin)}
													subTextClass={cx(s.subText, 'textWhiteTwo')}
													subText={formatMessage(messages.maximumUploadSizeLabel)}
													defaultMessage={formatMessage(messages.chooseFile)}
													postUrl={api.apiEndpoint + '/uploadHomepageImage'}
													handleDropzone={this.successAppStore}
													loaderName={'signupGridImage4Loader'}
													loader={signupGridImage4Loader}
													imageSrc={signupGridImage2 ? api.apiEndpoint + homepageUploadDir + signupGridImage2 : null}
													fieldName={'signupGridImage2'}
													formName={'SignupSettingsForm'}
													label={formatMessage(messages.signupImage2)}
													labelClass={cx(s.textAlignLeft, 'textAlignLeft', s.dropzoneLabelTitle)}
												/>
											</div>
										</div>
									</Form.Group>
								</Col>
								<Col lg={6} md={6} sm={12} xs={12}>
									<Form.Group className={cx(s.formGroup, 'mb30')}>
										<div>
											<Field name="signupGridLink1" type="text" component={this.renderField} label={formatMessage(messages.playstorelink)} inputClassname={'noMargin'} />
										</div>
									</Form.Group>
								</Col>
								<Col lg={6} md={6} sm={12} xs={12}>
									<Form.Group className={cx(s.formGroup, 'mb30')}>
										<div>
											<Field name="signupGridLink2" type="text" component={this.renderField} label={formatMessage(messages.appstorelink)} inputClassname={'noMargin'} />
										</div>
									</Form.Group>
								</Col>
								<Col lg={12} md={12} sm={12} xs={12}>
									<Form.Group className={cx(s.formGroup, 'mb0', bt.paddingTop5, bt.languageBtnDivider)}>
										<div>
											<FieldArray name='signupGridTitle1' type="text" component={this.renderFieldArray} />
										</div>
									</Form.Group>
								</Col>
								<Col lg={12} md={12} sm={12} xs={12} className={cx(bt.textAlignRight, bt.spaceTop5, bt.paddingTop5, bt.languageBtnDivider, 'textAlignLeftRTL', 'loadingBtnRTL')}>
									<Form.Group className={s.formGroup}>
										<div className={s.displayInlineBlock}>
											<Loader
												type={"button"}
												label={formatMessage(messages.submitButton)}
												show={loading}
												buttonType={'submit'}
												className={cx(bt.btnPrimary, bt.clickBtn)}
												disabled={submitting || loading}
												isSuffix={true}
											/>
										</div>
									</Form.Group>
								</Col>
							</Row>
						</Form>
					</Card>
				</div>
			</div>
		)
	}
}

SignupSettingsForm = reduxForm({
	form: 'SignupSettingsForm',
	onSubmit: submit,
	validate
})(SignupSettingsForm);

const selector = formValueSelector('SignupSettingsForm')

const mapState = (state) => ({
	signupGridImage1: selector(state, 'signupGridImage1'),
	signupGridImage2: selector(state, 'signupGridImage2'),
	signupGridImage3: selector(state, 'signupGridImage3'),
	signupGridImage4: selector(state, 'signupGridImage4'),
	loading: state?.loader?.SignupSettingsForm,
	signupGridImage1Loader: state?.loader?.signupGridImage1Loader,
	signupGridImage2Loader: state?.loader?.signupGridImage2Loader,
	signupGridImage3Loader: state?.loader?.signupGridImage3Loader,
	signupGridImage4Loader: state?.loader?.signupGridImage4Loader,
	dynamicSignupGridTitle: selector(state, 'signupGridTitle1'),
	languageList: state?.runtime?.availableLocales,
})
const mapDispatch = {
	updateTempImages,
	change
}
export default injectIntl(withStyles(s, bt)(connect(mapState, mapDispatch)(SignupSettingsForm)));
